import React from 'react';
import { motion } from "framer-motion";
import { registrarTablasPlanilla } from '../controllers/configuracionFirebase';
import { toast } from 'react-hot-toast';
import { Button } from 'primereact/button';
import { arreglarTiempoEstandar } from '../controllers/pdfs';
import { datosAdmin, departamentosColombia } from '../controllers/administrador';
import { Tag } from 'primereact/tag';

const TablaPruebas = ({pruebas, jornada, nadadores, idTorneoParticipando, invitado, usuario, fechaHoraRegistro, colorPdf, torneoEspecifico}) => {

  function registrarTablaIndividual(idPrueba){
    registrarTablasPlanilla(idTorneoParticipando, pruebas.filter((prue)=>{return prue.id === idPrueba})[0], nadadores[idPrueba - 1], fechaHoraRegistro);
    toast.success('Tabla registrada correctamente.');
  }

  function banderas(departamento, codePais){
    const buscarBandera = departamentosColombia.filter((depBan) => {return depBan.dep === (departamento ? departamento : 'Colombia')});
    const banderaPais = departamentosColombia.filter((depBan) => {return depBan.codePais === (codePais ? codePais : 'Colombia') && depBan.pais});
    if(buscarBandera.length !== 0){
      return <div className="position-relative m-auto" style={{width: '35px'}}>
        <img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={buscarBandera[0].bandera} alt='Bandera'/>
        {banderaPais[0]?.bandera ? <img className="position-absolute bottom-0 end-0 border" style={{width: '18px'}} src={banderaPais[0]?.bandera} alt='Bandera'/> : <></>}
      </div>
    }
  }
  
  return (
    <>
      <div className="alert alert-dismissible fade show" role="alert" style={{background: 'rgba(255,255,255,0.4)'}}>
        <h1 className='alert-heading'>{`Jornada ${jornada}`}</h1>    
      </div>
      <div className='d-flex flex-wrap justify-content-center'>
        {pruebas.map((prue, indexPrue)=>{
          return <form key={indexPrue} className='formulario-tablas'>
          <motion.table
          className='shadow tabla-tiempos'
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{duration: 1}}
          style={{margin: '4px', width: '530px', borderRadius: '20px 0', background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}
          >
            <thead className='text-light'>
              <tr style={{borderBottom: '1px solid white'}}>
                <td style={{fontSize: '16px', fontFamily: 'Fira Sans Extra Condensed'}} colSpan={9}>
                  <span className='d-flex justify-content-between aling-items-center'>
                    <div className='ms-1 mb-1'>
                      <Tag rounded className='me-1 bg-warning border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                      <Tag severity="success" rounded className='me-1 border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                      <Tag severity="danger" rounded className='border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                    </div>
                  </span>
                </td>
              </tr>
              <tr style={{borderBottom: '1px solid white'}}>
                <th className='id fs-4' style={{borderRight: '1px solid white'}}>{prue.id}</th>
                <th style={{fontSize: '18px'}} colSpan={4}>{`${prue.categoria}`}</th>
              </tr>
              <tr className='bg-light text-dark' style={{borderBottom: '1px solid white'}}>
                <th style={{fontSize: '18px'}} colSpan={!invitado && nadadores[prue.id - 1]?.length !== 0 ? 4 : 5}>{prue.prueba.prueba}</th>
                {!invitado && nadadores[prue.id - 1]?.length !== 0 ? (
                  <th>
                    <Button type='button' className='btn btn-dark' icon='pi pi-plus' onClick={()=> registrarTablaIndividual(prue.id)}></Button>
                  </th>
                ):(
                  <></>
                )}
              </tr>
            </thead>
            {
              nadadores[prue.id - 1] ?
              nadadores[prue.id - 1].length !== 0 ?
              nadadores[prue.id - 1].map((nadador, nadadorIndex)=>{
                return <tbody key={nadadorIndex}>
                  <tr>
                    <th className='text-light text-start ps-2' colSpan={5}>{`Serie: ${nadador.Serie}`}</th>
                  </tr>
                  {
                    nadador.nadadores.map((user, index)=>{
                      return user.nombre.length !== 0 ?(
                        <tr key={index}
                          style={{borderRadius: '20px 0', boxShadow: '0 3px 8px black', zIndex: `1.${index}`}}>
                          <td style={{fontSize: '14px', background: `${invitado ? usuario.nombreclub === user.nombreclub[0] ? `rgb(${colorPdf.r + ',' + colorPdf.g + ',' + colorPdf.b})` : 'white' : 'white'}`, borderRadius: '20px 0 0 0', borderRight: '1px solid #d8d8d8'}}>{user.carril}</td>
                          <td style={{fontSize: '14px', background: `${invitado ? usuario.nombreclub === user.nombreclub[0] ? `rgb(${colorPdf.r + ',' + colorPdf.g + ',' + colorPdf.b})` : 'white' : 'white'}`, borderRight: '1px solid #d8d8d8'}}>{banderas(user.departamento, user.codePais)}</td>
                          {user.equipo ?(
                            <td className='text-start' style={{fontSize: '14px', background: `${invitado ? usuario.nombreclub === user.nombreclub[0] ? `rgb(${colorPdf.r + ',' + colorPdf.g + ',' + colorPdf.b})` : 'white' : 'white'}`, borderRight: '1px solid #d8d8d8'}}>
                              {user.equipo.map((eq, indexEq)=>{
                                return <span key={indexEq}>{(user.ocultar && usuario.nombreclub !== datosAdmin.nombre && usuario.nombreclub !== 'PROWEBSPORTS') ? ('Deportista: ' + (indexEq + 1)) : eq} <hr className='m-0'/></span>
                              })}
                              <label className="w-100 text-end fw-bold" style={{fontSize: "11px"}}>{user.nombreclub}</label>
                            </td>
                          ):(
                            <td className='text-start' style={{fontSize: '14px', background: `${invitado ? usuario.nombreclub === user.nombreclub[0] ? `rgb(${colorPdf.r + ',' + colorPdf.g + ',' + colorPdf.b})` : 'white' : 'white'}`, borderRight: '1px solid #d8d8d8'}}>
                              <label className="d-flex flex-column">
                                <label style={{cursor: 'pointer'}}>{user.nombre} {user?.verificado === 'Verificado' ? <i title='Verificado' className='pi pi-verified text-primary bg-info rounded-circle'></i> : ''}</label>
                                <label className="text-end fw-bold" style={{fontSize: "11px"}}>{user.nombreclub}</label>
                              </label>
                            </td>
                          )}
                          {user.equipo ? (
                            <td style={{fontSize: '14px', background: `${invitado ? usuario.nombreclub === user.nombreclub[0] ? `rgb(${colorPdf.r + ',' + colorPdf.g + ',' + colorPdf.b})` : 'white' : 'white'}`, borderRight: '1px solid #d8d8d8'}}>
                              {user.edades.map((ed, indexEd) =>{
                                return <span key={indexEd}>{(user.ocultar && usuario.nombreclub !== datosAdmin.nombre && usuario.nombreclub !== 'PROWEBSPORTS') ? 0 : ed} <hr className='m-0'/></span>
                              })}
                              <label className="w-100 text-end fw-bold" style={{fontSize: "11px"}}></label>
                            </td>
                          ):(
                            <td style={{fontSize: '14px', background: `${invitado ? usuario.nombreclub === user.nombreclub[0] ? `rgb(${colorPdf.r + ',' + colorPdf.g + ',' + colorPdf.b})` : 'white' : 'white'}`, borderRight: '1px solid #d8d8d8'}}>{`${user.edad}`}</td>
                          )}
                          <td className='fw-bold' style={{fontSize: '14px', background: `${invitado ? usuario.nombreclub === user.nombreclub[0] ? `rgb(${colorPdf.r + ',' + colorPdf.g + ',' + colorPdf.b})` : 'white' : 'white'}`, borderRadius: '0 0 20px 0'}}>{user.records ?  user.records.filter((rec)=>{return rec.prueba === prue.prueba.id}).length !== 0 ?
                          arreglarTiempoEstandar(user.records.filter((rec)=>{return rec.prueba === prue.prueba.id})[0].record) : '' : ''}</td>
                        </tr>
                      ):(
                        <></>
                      )
                    })
                  }
                </tbody>
              })
              :
              <tbody>
                <tr>
                  <th className='text-light text-start ps-2' style={{borderBottom: '1px solid gray'}} colSpan={5}>Serie: 1</th>
                </tr>
                <tr>
                  <td className='bg-light' style={{ borderRadius: '0 0 20px 0' }} colSpan={5}>No hay deportistas aún.</td>
                </tr>
              </tbody>
              :
              <tbody>
                <tr>
                  <th className='text-light text-start ps-2' style={{borderBottom: '1px solid gray'}} colSpan={5}>Serie: 1</th>
                </tr>
                <tr>
                  <td className='bg-light' style={{ borderRadius: '0 0 20px 0' }} colSpan={5}>No hay deportistas aún.</td>
                </tr>
              </tbody>
            }
          </motion.table>
          </form>
        })}
      </div>
    </>
  );
}

export default TablaPruebas;